import PropTypes from 'prop-types';
import React from 'react';
import { Iterable } from 'immutable';
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap';

const EMPTY_USER_LABEL = 'No User Selected';

const validationState = (daemons, runAsUserEmail) => {
  if (runAsUserEmail) {
    return (daemons.map(user => user.email)
      .indexOf(runAsUserEmail) !== -1) ? 'success' : 'error';
  }
  return null;
};

const UserSelect = ({ scheduledUserOptions, scheduledUser, updateScheduledUser, label }) => (
  <FormGroup className='saved-job-user-group' validationState={validationState(scheduledUserOptions, scheduledUser)}>
    <ControlLabel>{label}</ControlLabel>
    <FormControl
      componentClass='select'
      value={scheduledUser}
      onChange={updateScheduledUser}
    >
      {scheduledUserOptions.map(user =>
        <option key={user.id} value={user.email}>{user.email || EMPTY_USER_LABEL}</option>)
      }
    </FormControl>
  </FormGroup>
);

export default UserSelect;

UserSelect.propTypes = {
  scheduledUserOptions: PropTypes.instanceOf(Iterable),
  scheduledUser: PropTypes.string,
  updateScheduledUser: PropTypes.func,
  label: PropTypes.string,
};
